<div class="input-group" [ngClass]="{ 'input-group-sm': small_input }">
  <input
    [(ngModel)]="intranetSearchTerm"
    type="text"
    name="intranet-search"
    [appAutocomplete]="'/intranets/field_search'"
    [data]="{ autocomplete: true }"
    (autocompleteSelect)="intranetSearchOnSelect($event)"
    [include_item]="include_item"
    [placeholder]="placeholder || 'Search for Intranet'"
    class="form-control"
    [disabled]="!select_only && (!!intranetId || !editable)"
    name="intranet_search"
    ngDefaultControl
  />
  <div class="input-group-append" style="padding: 0px !important" *ngIf="!select_only">
    <button type="button" class="btn btn-primary" [disabled]="!intranetId || !editable" (click)="clearSelectedIntranet()">
      <i class="fas fa-pencil-alt"></i>
    </button>
  </div>
</div>
